import { render } from "./AddCertificate.vue?vue&type=template&id=21f4db6c&scoped=true"
import script from "./AddCertificate.vue?vue&type=script&lang=js"
export * from "./AddCertificate.vue?vue&type=script&lang=js"

import "./AddCertificate.vue?vue&type=style&index=0&id=21f4db6c&lang=scss&scoped=true"

import exportComponent from "/Users/sivasankarelango/Sivasankar/cx-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21f4db6c"]])

export default __exports__